<div class="animated container-fluid">
    <form class="needs-validation" [formGroup]="form" novalidate>

        <h4 style="display:inline">{{ title }} Solicitud de Campaña</h4>
        <h4 style="display:inline">{{ solicitudCam?.Codigo }}</h4>
        <h5 style="display:inline; margin-left: 8px">
            <span>
                <img *ngIf="form.value.IdEstadoSolicitudCam" class="estado-icono-big" container="body" src="{{ form.value.IdEstadoSolicitudCam | IconoEstadoSolicitudCam }}" ngbTooltip="{{ solicitudCam?.EstadoSolicitudCam }}" />
                <img *ngIf="!form.value.IdEstadoSolicitudCam" class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitudCam }}" ngbTooltip="{{ 'Nueva' }}" />
            </span>
        </h5>
        <div claas="row ps-2">
            <ng-container *ngIf="hasRecintosPIAED && !readonly">
                <div class="col-12 mb-2 nota-info">
                    <label class="col-form-label" for=""><i class="fa fa-info-circle" aria-hidden="true"></i> Esta solicitud no permite editar la Campaña, Periodo, C.A. y/o Tipo de Solicitud, porque tiene {{ titleByTipoSolicitud.plural }} {{ vinculadosMessage }}.</label>
                </div>
            </ng-container>
            <ng-container *ngIf="EANoHabilitada && !readonly">
                <div class="col-12 mb-2 nota-info">
                    <label class="col-form-label" for=""><i class="fa fa-info-circle" aria-hidden="true"></i> La C.A. seleccionada no está habilitada para indicar Entidad Auditora en el periodo</label>
                </div>
            </ng-container>
            <ng-container *ngIf="periodos?.length === 0 && form?.value?.IdCampania !== null">
                <div class="col-12 mb-2 nota-info warning mb-2">
                    <label class="col-form-label" for=""><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> La campaña seleccionada no dispone de periodos correctamente configurados.</label>
                </div>
            </ng-container>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsedCabecera = !isCollapsedCabecera" [attr.aria-expanded]="!isCollapsedCabecera" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-file-text-o"></i> Datos Solicitud de Campaña
                            <i *ngIf="isCollapsedCabecera" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsedCabecera" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body-detalle">
                        <div class="collapse group-filtros" id="collapsedCabecera" [ngbCollapse]="isCollapsedCabecera">

                            <div class="row">

                                <div class="form-group col-xl-3 col-lg-4 col-md-3 col-sm-6">
                                    <label class="col-form-label required-field" for="IdCampania" title="Campaña Específica">Campaña</label>
                                    <ng-select appendTo="body"
                                        loadingText="Cargando..."
                                        [items]="campanias"
                                        [readonly]="!campanias || campanias.length === 0 || readonly || hasRecintosPIAED"
                                        bindLabel="Descripcion"
                                        bindValue="Id"
                                        formControlName="IdCampania"
                                        [loading]="campanias === null"
                                        placeholder="-- Seleccione una Campaña --"
                                        [ngClass]="displayFieldCssNgSelect('IdCampania')"
                                        (change)="onSelectCampania($event?.Id)"
                                        notFoundText="Campaña no encontrada"
                                        aria-describedby="validationFechaCreacionFeedback"
                                        clearAllText="Eliminar selección">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                        </ng-template>
                                    </ng-select>

                                    <div id="validationFechaCreacionFeedback" class="invalid-feedback d-block" *ngIf="isFieldInvalid('FechaSolicitud','solicitud_fuera_plazo', true)">
                                        Solicitud fuera de plazo de Presentación
                                    </div>
                                    <div id="validationCampaniaFeedback" class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdCampania','required')">
                                        Campaña es obligatoria
                                    </div>
                                </div>

                                <div class="form-group col-xl-3 col-lg-4 col-md-3 col-sm-6">
                                    <label class="col-form-label required-field" for="IdPeriodoCam" title="Periodo de la Campaña Específica">Periodo</label> <label class="small">(de la "Campaña")</label>
                                    <ng-select appendTo="body"
                                        loadingText="Cargando..."
                                        [items]="periodos"
                                        [readonly]="!periodos || periodos.length === 0 || readonly || hasRecintosPIAED"
                                        bindLabel="Descripcion"
                                        bindValue="Id"
                                        formControlName="IdPeriodoCam"
                                        [loading]="periodos === null && form.value.IdCampania !== null"
                                        placeholder="-- Seleccione un Periodo --"
                                        [ngClass]="displayFieldCssNgSelect('IdPeriodoCam')"
                                        (change)="onSelectPeriodo($event?.Id)"
                                        aria-describedby="validationPeriodoInvalid"
                                        notFoundText="Periodo no encontrado"
                                        clearAllText="Eliminar selección">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                        </ng-template>
                                    </ng-select>

                                    <div id="validationPeriodoInvalid" class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPeriodoCam','periodo_invalido', true)">
                                        Periodo inválido
                                    </div>
                                    <div id="validationPeriodoFeedback" class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPeriodoCam','required')">
                                        Periodo es obligatorio
                                    </div>
                                </div>

                                <div class="form-group col-xl-3 col-lg-4 col-md-3 col-sm-6">
                                    <label class="col-form-label required-field" for="IdCA" title="Comunidad Autónoma del Periodo">Com. Aut.</label> <label class="small">(del "Periodo")</label>
                                    <ng-select appendTo="body"
                                        loadingText="Cargando..."
                                        [items]="CAs"
                                        [readonly]="!CAs || CAs.length === 0 || readonly || hasRecintosPIAED"
                                        placeholder="-- Seleccione una C.A. --"
                                        [loading]="CAs === null && form.value.IdPeriodoCam !== null"
                                        bindLabel="ComunidadAutonoma"
                                        bindValue="IdCa"
                                        formControlName="IdCA"
                                        [ngClass]="displayFieldCssNgSelect('IdCA')"
                                        (change)="onSelectCA($event)"
                                        aria-describedby="validationCaInvalid"
                                        notFoundText="C.A. no encontrada"
                                        clearAllText="Eliminar selección">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{ item.ComunidadAutonoma }}">{{ item.ComunidadAutonoma }}</div>
                                        </ng-template>
                                    </ng-select>

                                    <div id="validationCaInvalid" class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdCA','ca_invalida', true)">
                                        Comunidad Autónoma inválida
                                    </div>
                                    <div id="validationCAFeedback" class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdCA','required')">
                                        Comunidad Autónoma es obligatoria
                                    </div>
                                </div>

                                <div class="form-group col-xl-3 col-lg-4 col-md-3 col-sm-6">
                                    <label class="col-form-label" title="Entidad Auditora de la Comunidad Autónoma" 
                                        [ngClass]="{ 'required-field': entidadAuditoraEnabledForCA}" for="IdEntidadAuditora">Ent. Aud.</label> <label class="small">(de la "Comunidad")</label>
                                    <ng-select appendTo="body"
                                        loadingText="Cargando..."
                                        [items]="EAs"
                                        [readonly]="EAs === null || form.value.IdCA === null || !entidadAuditoraEnabledForCA || readonly"
                                        placeholder="-- Seleccione una E.A. --"
                                        [loading]="!EAs && (form.value.IdCA !== null) && entidadAuditoraEnabledForCA"
                                        bindLabel="Descripcion"
                                        bindValue="Id"
                                        formControlName="IdEntidadAuditora"
                                        aria-describedby="validationEAFeedback"
                                        [ngClass]="displayFieldCssNgSelect('IdEntidadAuditora')"
                                        notFoundText="E.A. no encontrada"
                                        clearAllText="Eliminar selección">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                        </ng-template>
                                    </ng-select>

                                    <div id="validationEAFeedback" class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdEntidadAuditora','ea_no_configurada', true)">
                                        Entidad Auditora no configurada para el Periodo
                                    </div>

                                    <div id="validationEAFeedback" class="invalid-feedback d-block" *ngIf="entidadAuditoraEnabledForCA && isFieldInvalid('IdEntidadAuditora','cannotBeNullOrZero', true)">
                                        Entidad Auditora es obligatoria
                                    </div>
                                </div>

                                <div class="form-group col-xl-3 col-lg-4 col-md-3 col-sm-6">
                                    <label class="col-form-label required-field" for="IdTipoSolicitudCam" title="Tipo de Recinto del Periodo">Tipo de Recinto</label> <label class="small">(o Solicitud)</label>
                                    <ng-select appendTo="body"
                                        loadingText="Cargando..."
                                        [items]="tiposSolicitud"
                                        [readonly]="!tiposSolicitud || tiposSolicitud.length === 0 || readonly || hasRecintosPIAED"
                                        placeholder="-- Seleccione un Tipo de Recinto --"
                                        [loading]="tiposSolicitud === null && form.value.IdPeriodoCam !== null"
                                        bindLabel="Descripcion"
                                        bindValue="IdTipoSolicitud"
                                        aria-describedby="validationTipoInvalid"
                                        formControlName="IdTipoSolicitudCam"
                                        [ngClass]="displayFieldCssNgSelect('IdTipoSolicitudCam')"
                                        notFoundText="Tipo de Recinto no encontrado"
                                        clearAllText="Eliminar selección">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                        </ng-template>
                                    </ng-select>

                                    <div id="validationTipoInvalid" class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdTipoSolicitudCam', 'tipo_solicitud_invalido', true)">
                                        Tipo de Recinto inválido
                                    </div>                                    

                                    <div id="validationTipoRecintoFeedback" class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdTipoSolicitudCam','required')">
                                        Tipo de Recinto es obligatorio
                                    </div>
                                </div>

                                <div *ngIf="solicitudCam" class="form-group col-xl-3 col-lg-4 col-md-3 col-sm-6">
                                    <label class="col-form-label" for="Codigo">Código</label>
                                    <!-- This field is disabled when building on the parent -->
                                    <input formControlName="Codigo" name="Codigo"
                                        class="form-control" id="Codigo" type="text" value="">
                                </div>

                                <div *ngIf="solicitudCam" class="form-group col-xl-3 col-lg-4 col-md-3 col-sm-6">
                                    <label class="col-form-label" for="FechaSolicitud">Fecha Solicitud</label>
                                    <!-- This field is disabled when building on the parent -->
                                    <p-calendar appendTo="body" formControlName="FechaSolicitud" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy" [showTime]="true" hourFormat="24"></p-calendar>
                                </div>
                                
                                <div *ngIf="solicitudCam" class="form-group col-xl-3 col-lg-4 col-md-3 col-sm-6">
                                    <label class="col-form-label" for="EstadoSolicitudCam">Estado</label>
                                    <!-- This field is disabled when building on the parent -->
                                    <input formControlName="EstadoSolicitudCam" name="EstadoSolicitudCam" class="form-control" inputStyleClass="form-control" [ngClass]="displayFieldCss('EstadoSolicitudCam')" type="text" value="">
                                </div>        
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsedDatosOperador = !isCollapsedDatosOperador" [attr.aria-expanded]="!isCollapsedDatosOperador" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-file-text-o"></i> Datos Operador de Campaña
                            <i *ngIf="isCollapsedDatosOperador" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsedDatosOperador" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body-detalle">
                        <div class="collapse group-filtros" id="collapsedCabeceraOperador" [ngbCollapse]="isCollapsedDatosOperador">

                            <div class="row">

                                <div *ngIf="solicitudCam || usuarioExterno" class="form-group col-xl-3 col-lg-4 col-md-3 col-sm-6">
                                    <label class="col-form-label" for="OperadorRazonSocial">Razón Social</label>
                                    <!-- This field is disabled when building on the parent -->
                                    <input formControlName="OperadorRazonSocial" name="OperadorRazonSocial"
                                        class="form-control" id="OperadorRazonSocial" type="text" value="">
                                </div>
                                
                                <div *ngIf="solicitudCam || usuarioExterno" class="form-group col-xl-3 col-lg-4 col-md-3 col-sm-6">
                                    <label class="col-form-label" for="OperadorNif">NIF</label>
                                    <!-- This field is disabled when building on the parent -->
                                    <input formControlName="OperadorNif" name="OperadorNif"
                                        class="form-control" id="OperadorNif" type="text" value="">
                                </div>

                                <div *ngIf="solicitudCam || usuarioExterno" class="form-group col-xl-3 col-lg-4 col-md-3 col-sm-6">
                                    <label class="col-form-label" for="OperadorTelefono">Teléfono</label>
                                    <!-- This field is disabled when building on the parent -->
                                    <input formControlName="OperadorTelefono" name="OperadorTelefono"
                                        class="form-control" id="OperadorTelefono" type="text" value="">
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="container-list" *ngIf="esTipoRecintosPI && variedades">
            <app-variedad-list [lastFilter]="variedadesLastFilter" [selectionMode]="dialogSelectionMode" [result]="variedades"></app-variedad-list>
        </div>

    </form>

</div>